/**
 * Цвета группировки участников раунда классика.
 *
 * Палитра и правило «одна банда — один цвет» живут в общем модуле
 * `src/utils/participantColors.js`: те же цвета использует командный кейсбатл,
 * поэтому одна банда выглядит одинаково во всех режимах. Здесь остаётся только
 * специфичная для классика подпись состава банд.
 */

export {
  PARTICIPANT_PALETTE,
  hashString,
  pickPaletteColor,
  lightenHex,
  buildTeamColorMap
} from '../../../utils/participantColors'

/**
 * Подпись состава банд для React.memo/useMemo: пересчитываем цвета и сводку
 * только когда реально изменились состав, доли или возвраты.
 */
export const buildTeamsSignature = (teams = []) => (teams || [])
  .map((team) => [
    team?.slug || '',
    team?.is_team ? 1 : 0,
    Number(team?.total_crystal || 0),
    Number(team?.percent || 0),
    Number(team?.count_users || 0),
    Number(team?.refund || 0)
  ].join(':'))
  .sort()
  .join('|')
